import * as React from 'react';
import { compose } from 'redux';

import { AuthenticationHelpButton } from '../../../NavbarHelpButton';
import Navbar from '../../../Navbar';
import LoginByPasswordTip from '../../../LoginByPasswordTip';
import { useTranslation, config } from '@shopee-user/platform';
import { useResponsiveLayout, Layout } from '@shopee-user/layout-responsive';

// HOCs and Types
import {
  withUserWebView,
  WithUserWebViewProps,
} from '@shopee-user/with-web-view';
import { LoginByPasswordOneCredentialRequireAuthKeyProps } from '@shopee-user/business-customization-types';
import { useLoginByPasswordOneCredentialOptionalFlowEvent } from '@tob/pages/login-by-password-one-credential-optional/flow-event';

function Header({
  webViewNavigateBack,
  state: { shouldHideBack, shouldShowLoginTip },
}: LoginByPasswordOneCredentialRequireAuthKeyProps & WithUserWebViewProps) {
  const I18n = useTranslation();
  const { layout } = useResponsiveLayout();

  const { trackEvent } = useLoginByPasswordOneCredentialOptionalFlowEvent();

  return (
    <>
      <Navbar
        title={I18n.t('label_auth_log_in', { context: config.BUSINESS_TARGET })}
        onClickBack={() => {
          trackEvent('onLoginBackClick');
          webViewNavigateBack();
        }}
        rightContent={
          <AuthenticationHelpButton
            text={I18n.t('label_auth_help')}
            onClick={() => trackEvent('onLoginHelpClick')}
          />
        }
        shouldHideBack={shouldHideBack}
      />
      {shouldShowLoginTip && layout === Layout.Desktop && (
        <LoginByPasswordTip />
      )}
    </>
  );
}

export default compose<React.ComponentType>(withUserWebView({}))(Header);
